/**
 * Returns a date object with the time removed from the given date
 * @param date  The date as a string or a date object from which time should be removed
 */
export const getDateWithoutTime = (date: Date | string): Date =>
  new Date(
    date instanceof Date ? date.toDateString() : new Date(date).toDateString(),
  );
